import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setAlternateUser } from '../slices/alternateUserSlice';
import { store } from '../store';

export const addAlternateUser = async (body) => {
  const res = await handlePostRequest(URI.alternate_user, body);
  if (res?.ack) getAlternateUsers();
  return res;
};

export const getAlternateUsers = async ({
  page = 1,
  primary_user_id,
  secondary_user_id,
  start_date,
  end_date,
} = {}) => {
  const res = await handleGetRequest(URI.alternate_user, null, {
    params: { page, primary_user_id, secondary_user_id, start_date, end_date },
  });
  if (res?.ack) store.dispatch(setAlternateUser(res));
  return res;
};

export const updateAlternateUsers = async (body) => {
  const filters = store.getState().filtersSlice.alternateFilters;
  const res = await handlePutRequest(URI.alternate_user_id(body?.id), body);
  if (res?.ack) getAlternateUsers(filters || {});
  return res;
};

export const deleteAlternateUser = async (id) => {
  const filters = store.getState().filtersSlice.alternateFilters;
  const res = await handleDeleteRequest(URI.alternate_user_id(id));
  if (res?.ack) getAlternateUsers(filters || {});
  return res;
};
